import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import { isUserReadOnly } from 'utils/accessHelper';

class JobListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { disableButton: { print: false } };
  }

  _isEditable() {
    let isEditable = !isUserReadOnly();
    if (this.props.myjobsSetting) {
      if (['submitted', 'in_progress'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_submission;
      } else if (['completed'].indexOf(this.props.data.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_completion;
      }
    }

    return isEditable;
  }

  _archive = () => {
    this.props.dispatch(ReduxActions.job.archive(this.props.data.id));
  }

  _unarchive = () => {
    this.props.dispatch(ReduxActions.job.unarchive(this.props.data.id));
  }

  _print = () => {
    JobHelper.print(this.props.data.id);
    this._disableButton('print');
  }

  _submit = () => {
    this.props.dispatch(ReduxActions.job.submit(this.props.data.id));
  }

  _revoke = () => {
    this.props.dispatch(ReduxActions.job.revoke(this.props.data.id));
  }

  _viewDetail = () => {
    Utils.Router.transitionFromSubpath('jobs', this.props.data.id);
  }

  _cancel = () => {
    if (!Utils.Helper.isNullOrUndefined(this.props.showCancelModal)) {
      this.props.showCancelModal(this.props.data.id);
    }
  }

  _disableButton(buttonName) {
    this.setState(prevState => ({
      disableButton: { ...prevState.disableButton, [buttonName]: true },
    }), async () => {
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.setState(prevState => ({
        disableButton: { ...prevState.disableButton, [buttonName]: false },
      }));
    });
  }

  _renderInProgressIcon(completedCount, totalCount) {
    const ratio = completedCount / totalCount;
    const side = 50 * Math.tan(Math.PI * 2 * (ratio % 0.25));

    if (ratio === 0) {
      const iconClassName = (this.props.data.job_type === 'delivery') ? 'versa-base-delivery'
        : 'versa-base-pickup';
      return (
        <Components.LineItem.IconBlock
          iconClassName={iconClassName}
          iconText=""
        />
      );
    }

    if (totalCount === 1 && ratio < 1) {
      return (
        <Components.LineItem.IconBlock
          iconClassName="versa-otw"
          iconText=""
        />
      );
    }

    if (ratio === 1) {
      return (
        <Components.LineItem.IconBlock
          className="vf-job__list-item__icon--completed"
          iconClassName="versa-completed"
          iconText=""
        />
      );
    }

    let part1 = false;
    let part2 = false;
    let part3 = false;

    if (ratio >= 0.5) {
      part1 = <rect height="50" width="50" x="50" y="50" />;
    } else if (ratio > 0.25) {
      part1 = <polygon points={`50,50 100,50 100,${50 + side}`} />;
    }

    if (ratio >= 0.75) {
      part2 = <rect height="50" width="50" x="0" y="50" />;
    } else if (ratio > 0.5) {
      part2 = <polygon points={`50,50 50,100 ${50 - side},100`} />;
    }

    if (ratio >= 1.0) {
      part3 = <rect height="50" width="50" x="0" y="0" />;
    } else if (ratio > 0.75) {
      part3 = <polygon points={`50,50 0,50 0,${50 - side}`} />;
    }

    return (
      <Components.LineItem.Block size="SMALL">
        <div className="vf-job__list-item__pie-svg">
          <svg viewBox="0 0 100 100">
            {
              ratio >= 0.25
                ? <rect height="50" width="50" x="50" y="0" />
                : <polygon points={`50,50 50,0 ${50 + side},0`} />
            }
            {part1}
            {part2}
            {part3}
          </svg>
        </div>
      </Components.LineItem.Block>
    );
  }

  _renderCol1() {
    const completedCount = 0;

    switch (this.props.data.state) {
      case 'completed':
        return (
          <Components.LineItem.IconBlock
            iconClassName="versa-completed"
          />
        );
      case 'in_progress':
        if (completedCount === 0) {
          return this._renderInProgressIcon(0, 1);
        }
        return this._renderInProgressIcon(this.props.data.task_summary.task_count,
          this.props.data.task_summary.successful_task_count);

      case 'draft':
        return (
          <div className="vf-job__list-item__icon--dots">
            <span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </div>
        );
      case 'rejected':
        return (
          <Components.LineItem.IconBlock
            iconClassName="versa-warning vf-job__list-item__icon--rejected"
            iconText=""
          />
        );
      case 'submitted':
        return (
          <Components.LineItem.IconBlock
            iconClassName="versa-business vf-job__list-item__icon--submitted"
          />
        );
      default:
        return (
          <Components.LineItem.IconBlock
            iconClassName="versa-otw"
            iconText=""
          />
        );
    }
  }

  _renderCol2() {
    return (
      <Components.LineItem.Block>
        <Components.LineItem.BlockContent fontColor="BLACK" fontSize="LARGE">
          {this.props.data.guid}
        </Components.LineItem.BlockContent>
        <Components.LineItem.BlockContent fontColor="TRANSLUCENT">
          {`${this.props.data.task_summary.task_count
          } ${this.props.data.job_type === 'delivery' ? 'Deliveries' : 'Pickups'}`}
        </Components.LineItem.BlockContent>
      </Components.LineItem.Block>
    );
  }

  _renderCol3() {
    return (
      <Components.LineItem.Block>
        <Components.LineItem.BlockContent>
          {Utils.Formatter.getInlineAddress(
            (this.props.data.base_task || {}).address,
          )}
        </Components.LineItem.BlockContent>
        <Components.LineItem.BlockContent isDisplayBlock>
          <Components.Tags tags={(this.props.data.tags || []).map(tag => tag.name)} />
        </Components.LineItem.BlockContent>
      </Components.LineItem.Block>
    );
  }

  _renderCol4() {
    return (
      <Components.LineItem.Block>
        <Components.LineItem.BlockContent isDisplayBlock>
          <Components.Tags tags={(this.props.data.tags || []).map(tag => tag.name)} />
        </Components.LineItem.BlockContent>
      </Components.LineItem.Block>
    );
  }

  _renderCol5() {
    const { account, strings } = this.props;

    const taskSummary = this.props.data.task_summary;
    const measurementUnits = Utils.Helper.getMeasurementUnits();
    let totalVolumetricWeight = Utils.Helper.calculateVolumetricWeight(
      taskSummary.total_volume,
      account.shipping_factor,
      account.unit_system,
    );
    if (!Number.isFinite(Number(totalVolumetricWeight))) {
      totalVolumetricWeight = 0;
    }

    const volumeUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].volumeUnit : 'in³';
    const weightUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].weightUnit : 'lb';

    const renderedTotalWeight = Utils.Helper.isNullOrUndefined(taskSummary.total_weight) ? ''
      : `, ${Utils.Helper.roundToMinTwoDp(taskSummary.total_weight)} ${weightUnit}`;
    const renderedTotalVolume = Utils.Helper.isNullOrUndefined(taskSummary.total_volume) ? ''
      : `, ${Utils.Helper.roundToMinTwoDp(taskSummary.total_volume)} ${volumeUnit}`;
    const renderedTotalVolumetricWeight = (totalVolumetricWeight === 0) ? ''
      : `, ${Utils.Helper.roundToTwoDecimalPlaces(totalVolumetricWeight)} ${weightUnit}`;
    const renderedText = `${taskSummary.item_count} ${strings.constants.lineItem}, `
      + `${taskSummary.item_quantity_count} ${strings.constants.item}`
      + `${renderedTotalWeight}${renderedTotalVolume}${renderedTotalVolumetricWeight}`;
    return (
      <Components.LineItem.Block>
        <Components.LineItem.BlockContent>
          {(taskSummary.item_count > 0 ? renderedText : false)}
        </Components.LineItem.BlockContent>
      </Components.LineItem.Block>
    );
  }

  _renderActionButtons() {
    const cancelButton = this._isEditable() && this.props.data.cancellable
    && ['draft', 'submitted', 'rejected'].indexOf(this.props.data.state) > -1
      ? (
        <Components.Button
          hint={this.props.strings.page.buttons.cancel}
          iconClassName="versa-danger"
          id={`${this.props.id}__cancel-button`}
          onClick={this._cancel}
        />
      ) : false;
    let actionButton;
    if (this.props.archived) {
      return (
        <Components.LineItem.ButtonGroup>
          <Components.Button
            disabled={this.state.disableButton.print}
            hint={this.props.strings.page.buttons.print}
            iconClassName="versa-print"
            id={`${this.props.id}__print-button`}
            onClick={this._print}
          />
          {this._isEditable() ? (
            <Components.Unarchive
              id={`${this.props.id}__unarchive-button`}
              modelName={this.props.strings.constants.job}
              onClick={this._unarchive}
            />
          ) : false}
        </Components.LineItem.ButtonGroup>
      );
    }
    switch (this.props.data.state) {
      case 'draft':
        actionButton = (
          <Components.Button
            hint={this.props.strings.page.buttons.submit}
            iconClassName="versa-completed"
            id={`${this.props.id}__submit-button`}
            onClick={this._submit}
            withDefaultText
          />
        );
        break;
      case 'rejected':
        actionButton = (
          <Components.Button
            hint={this.props.strings.page.buttons.resubmit}
            iconClassName="versa-completed"
            id={`${this.props.id}__resubmit-button`}
            onClick={this._submit}
            text={this.props.isSubmittingJob ? 'Resubmitting' : 'Resubmit'}
          />
        );
        break;
      case 'submitted':
        actionButton = (
          <Components.Button
            hint={this.props.strings.page.buttons.revoke}
            iconClassName="versa-retract"
            iconText=""
            id={`${this.props.id}__revoke-button`}
            onClick={this._revoke}
            withDefaultText
          />
        );
        break;
      default:
        actionButton = false;
        break;
    }

    if (this.props.data.state === 'in_progress') {
      return (
        <Components.LineItem.ButtonGroup>
          <Components.Button
            disabled={this.state.disableButton.print}
            hint={this.props.strings.page.buttons.print}
            iconClassName="versa-print"
            id={`${this.props.id}__print-button`}
            onClick={this._print}
          />
          {cancelButton}
        </Components.LineItem.ButtonGroup>
      );
    }

    return (
      <Components.LineItem.ButtonGroup>
        <Components.Button
          disabled={this.state.disableButton.print}
          hint={this.props.strings.page.buttons.print}
          iconClassName="versa-print"
          id={`${this.props.id}__print-button`}
          onClick={this._print}
        />
        {
          this._isEditable() ? (
            <Components.Archive
              archive={this._archive}
              archivePath={() => Utils.Router.transitionTo('/archives/jobs')}
              ids={[this.props.data.id]}
              modelName={this.props.strings.constants.job}
              updateContent={() => {
                this.props.dispatch(ReduxActions.job.fetchList());
              }}
            >
              <Components.Button
                hint={this.props.strings.page.buttons.archive}
                iconClassName="versa-archive"
                id={`${this.props.id}__archive-button`}
              />
            </Components.Archive>
          ) : false
        }
        {actionButton}
        {cancelButton}
      </Components.LineItem.ButtonGroup>
    );
  }

  render() {
    return (
      <div>
        <Components.LineItem
          checkItem={this.props.checkItem}
          checkedStatus={this.props.checkedStatus}
          id={this.props.id}
          itemID={this.props.data.id}
          onClick={this._viewDetail}
          showCheckBox
        >
          {this._renderCol1()}
          {this._renderCol2()}
          <Components.LineItem.Divider />
          {this._renderCol3()}
          {!this.props.archived ? <Components.LineItem.Divider /> : false}
          {!this.props.archived ? this._renderCol4() : false}
          {!this.props.archived ? <Components.LineItem.Divider /> : false}
          {!this.props.archived ? this._renderCol5() : false}
          {this._renderActionButtons()}
        </Components.LineItem>
      </div>
    );
  }
}

JobListItem.propTypes = {
  account: PropTypes.shape().isRequired,
  archived: PropTypes.bool,
  checkItem: PropTypes.func,
  checkedStatus: PropTypes.bool,
  data: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  isSubmittingJob: PropTypes.bool,
  myjobsSetting: PropTypes.shape({
    can_edit_after_completion: PropTypes.bool,
    can_edit_after_submission: PropTypes.bool,
  }),
  showCancelModal: PropTypes.func,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      item: PropTypes.string,
      lineItem: PropTypes.string,
      job: PropTypes.string,
    }),
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        cancel: PropTypes.string,
        print: PropTypes.string,
        archive: PropTypes.string,
        unarchive: PropTypes.string,
        submit: PropTypes.string,
        resubmit: PropTypes.string,
        revoke: PropTypes.string,
      }),
    }),
  }).isRequired,
};

JobListItem.defaultProps = {
  archived: false,
  checkItem: null,
  checkedStatus: false,
  id: 'vf-job__list-item',
  isSubmittingJob: false,
  myjobsSetting: null,
  showCancelModal: null,
};

const mapStateToProps = (state) => {
  const { profile } = state;
  return {
    myjobsSetting: (profile.profile || {}).myjobs_setting,
  };
};

export default connect(mapStateToProps)(translate('Job')(JobListItem));
